import { Box, makeStyles } from "@material-ui/core";
import { DsExternalTextLink, DsText } from "@mvp/design-system";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import config from "../config";

const useStyles = makeStyles((theme) => ({
  box: {
    backgroundColor: theme.palette.grey[100],
    margin: "0 0 0 -2.5rem",
    padding: "1.25rem 2.5rem",
    maxWidth: "68.75rem",
    
    [theme.breakpoints.up("xl")]: {
      margin: "0 -4.5rem",
      padding: "1.25rem 4.5rem",
    },

    [theme.breakpoints.down("sm")]: {
      margin: "0 -1.25rem",
      padding: "1.25rem"
    },
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 400,
    color: (theme.palette as any).text.light
  },
  link: {
    fontWeight: 600,
  },
}));

export const DonateLifeFooter = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.box}>
      <DsText variant="subtitle2" className={classes.text}>
        <Trans
          t={t}
          i18nKey="donateLife.footer.text"
          components={{
            LinkComponent: (
              <DsExternalTextLink
                href={`https://${config.DONATE_LIFE_SUB_URL}`}
                text={config.DONATE_LIFE_SUB_URL}
                color="primary"
                openInNewTab
                className={classes.link}
              />
            ),
          }}
        />
      </DsText>
    </Box>
  );
};
